import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ScreenType } from 'src/app/enums/ScreenType';
import { AttendandeObject, IEmployee } from 'src/app/models/IEmployee';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
// import { EmployeeReportDetailsComponent } from '../employee-report-details/employee-report-details.component';
import { ExcelService } from 'src/app/services/attendance-excel';

@Component({
  selector: 'app-employee-attendance-report',
  templateUrl: './employee-attendance-report.component.html',
  styleUrls: ['./employee-attendance-report.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class EmployeeAttendanceReportComponent implements AfterViewInit {
  EmployeeDataSource: any;
  @Input() set employees(val: AttendandeObject) {
    this.EmployeeDataSource = val;
    if (val.EmployeeDataSource.length > 0) {
      this.dataSourceWithIndex = val.EmployeeDataSource.map(
        (element, index) => ({
          ...element,
          Index: index + 1,
        })
      );
      this.dataSource = new MatTableDataSource(this.dataSourceWithIndex);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.getAttendaceFromDatasource();
      this.totalEmployeeWeeks =
        val.EmployeeDataSource[0].groupedEmployeeAttendanceLogWeeks.length;
      this.numberOfPreviousWeeks = this.totalEmployeeWeeks;
      this.previousWeeksReport = this.getPreviousWeeksReports();
      this.currentWeekReport =
        this.previousWeeksReport[this.totalEmployeeWeeks - 1];
    }
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSourceWithIndex: IEmployee[] = [];
  dataSource: MatTableDataSource<IEmployee>;
  explicitColumns: string[] = [
    'no',
    'FullName',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];
  numberOfPreviousWeeks: number;
  totalEmployeeWeeks: number;
  dynamicColumns: string[] = [];
  columnsToDisplayWithExpand = [...this.explicitColumns];
  expandedElement: IEmployee | null;
  screenSize: ScreenType;
  ScreenType = ScreenType;
  index: number = 0;
  todaysDay = new Date().getDay();
  selectedTimeRange: 'weekly' | 'monthly' = 'weekly';
  currentWeekReport: IWeekReport[] = [];
  previousWeeksReport: IWeekReport[][] = [];
  currentWeek:
    | 'firstWeek'
    | 'secondWeek'
    | 'thirdWeek'
    | 'fourthWeek'
    | 'fifthWeek';
  currentWeekNumber: number;

  constructor(
    private screen: AumyeResponsiveScreenService,
    private dialog: MatDialog,
    private excel: ExcelService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
    this.getAttendaceFromDatasource();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, 1000);
  }
  onPreviousButtonClick() {
    this.numberOfPreviousWeeks = this.numberOfPreviousWeeks - 1;
    this.currentWeekReport =
      this.previousWeeksReport[this.numberOfPreviousWeeks - 1];
  }
  onNextButtonClick() {
    this.numberOfPreviousWeeks = this.numberOfPreviousWeeks + 1;
    this.currentWeekReport =
      this.previousWeeksReport[this.numberOfPreviousWeeks - 1];
  }
  onCurrentButtonClick() {
    this.numberOfPreviousWeeks = this.totalEmployeeWeeks;
    this.currentWeekReport =
      this.previousWeeksReport[this.numberOfPreviousWeeks - 1];
  }
  // onClickedRow(val: IEmployee) {
  //   this.dialog.open(EmployeeReportDetailsComponent, {
  //     disableClose: true,
  //     data: val,
  //   });
  // }
  areDatesEqual(date1: Date): boolean {
    let date2 = new Date();
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  }

  downloadAttendance() {
    this.excel.exportToExcel(this.EmployeeDataSource);
  }

  getAttendaceFromDatasource() {
    const logDate: Date = new Date();
    let week: any = null;
    const weekNumber: number = Math.floor((logDate.getDate() - 1) / 7) + 1;
    this.currentWeekNumber = weekNumber;
    switch (weekNumber) {
      case 1:
        week = 'firstWeek';
        break;
      case 2:
        week = 'secondWeek';
        break;
      case 3:
        week = 'thirdWeek';
        break;
      case 4:
        week = 'fourthWeek';
        break;
      case 5:
        week = 'fifthWeek';
        break;
    }
    this.currentWeek = week;
  }
  getWeekView(weekNumber: number) {
    let week: any = null;
    switch (weekNumber) {
      case 1:
        week = 'firstWeek';
        break;
      case 2:
        week = 'secondWeek';
        break;
      case 3:
        week = 'thirdWeek';
        break;
      case 4:
        week = 'fourthWeek';
        break;
      case 5:
        week = 'fifthWeek';
        break;
    }
    this.currentWeek = week;
  }
  toggleExpandedElement(element: IEmployee, event: Event): void {
    this.expandedElement = this.expandedElement === element ? null : element;
    event.stopPropagation();
  }
  getExpandState(element: IEmployee): string {
    return element === this.expandedElement ? 'expanded' : 'collapsed';
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    this.dataSource.filterPredicate = (data: any, filter: string) => {
      // Create full name from firstName and lastName
      const fullName = `${data.firstName} ${data.lastName}`.toLowerCase();
      const filterTerms = filter.trim().toLowerCase().split(' ');

      // Check if all filter terms are present in the full name
      return filterTerms.every((term) => fullName.includes(term));
    };

    this.dataSource.filter = filterValue;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  columnsToDisplay: string[] = [];
  updateDisplayedColumns(): void {
    // Clear existing columns
    this.columnsToDisplay = [];

    // Add explicit columns
    this.columnsToDisplay.push(...this.explicitColumns);

    // Add dynamic columns based on the selected time range
    if (this.selectedTimeRange === 'weekly') {
      const startOfWeek = this.getStartOfWeek();
      for (let i = 0; i < 7; i++) {
        const currentDate = new Date(startOfWeek);
        currentDate.setDate(startOfWeek.getDate() + i);
        const columnDate = currentDate.toISOString().split('T')[0];
        this.dynamicColumns.push(columnDate);
      }
    } else if (this.selectedTimeRange === 'monthly') {
      const startOfMonth = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      );
      const daysInMonth = new Date(
        new Date().getFullYear(),
        new Date().getMonth() + 1,
        0
      ).getDate();
      for (let i = 0; i < daysInMonth; i++) {
        const currentDate = new Date(startOfMonth);
        currentDate.setDate(startOfMonth.getDate() + i);
        const columnDate = currentDate.toISOString().split('T')[0];
        this.dynamicColumns.push(columnDate);
      }
    }

    // Add dynamic columns to columnsToDisplay
    this.columnsToDisplay.push(...this.dynamicColumns);
  }

  getStartOfWeek(): Date {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - dayOfWeek);
    return startOfWeek;
  }

  isToday(date: string): boolean {
    return date === new Date().toISOString().split('T')[0];
  }
  getCurrentWeekReport(): IWeekReport[] {
    const today = new Date();
    const currentDay = today.getDay();
    const diff = today.getDate() - currentDay + (currentDay === 0 ? -6 : 1); // Adjust when day is Sunday

    const startOfWeek = new Date(today);
    startOfWeek.setDate(diff);
    startOfWeek.setHours(0, 0, 0, 0);

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    endOfWeek.setHours(23, 59, 59, 999);

    const weekReport: IWeekReport[] = [];
    for (
      let i = new Date(startOfWeek);
      i <= endOfWeek;
      i.setDate(i.getDate() + 1)
    ) {
      weekReport.push({
        day: this.getDayOfWeek(i.getDay()),
        date: new Date(i),
        valid: i <= today, // Set valid to true if the date is less than or equal to today's date
      });
    }

    return weekReport;
  }
  getDayOfWeek(dayIndex: number): string {
    const daysOfWeek = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    return daysOfWeek[dayIndex];
  }

  getPreviousWeeksReports(): IWeekReport[][] {
    const previousWeeksReports: IWeekReport[][] = [];

    for (let week = this.numberOfPreviousWeeks - 1; week >= 0; week--) {
      const startOfWeek = new Date();
      startOfWeek.setDate(
        startOfWeek.getDate() - (7 * week + ((startOfWeek.getDay() + 6) % 7))
      );

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6);
      endOfWeek.setHours(23, 59, 59, 999);

      const weekReport: IWeekReport[] = [];
      for (
        let i = new Date(startOfWeek);
        i <= endOfWeek;
        i.setDate(i.getDate() + 1)
      ) {
        weekReport.push({
          day: this.getDayOfWeek(i.getDay()),
          date: new Date(i),
          valid: i <= new Date(),
        });
      }

      previousWeeksReports.push(weekReport);
    }

    return previousWeeksReports;
  }
}

export interface IWeekReport {
  day: string;
  date: Date;
  valid: boolean;
}
export interface IMonthReport {
  firstWeek: IWeekReport[];
  secondWeek: IWeekReport[];
  thirdWeek: IWeekReport[];
  fourthWeek: IWeekReport[];
  fifthWeek: IWeekReport[];
}
